import React from "react";
import { Typography, Grid, Button } from "@mui/material";
import "../Header/header.css";

const Footer = () => {
  return (
    <>
      <Grid container sx={{ background: "#1976D2", padding: "20px" }}>
        <Grid item xs={12} md={5}>
          <Typography className="footer-text">
            <b>Mailing Address:</b> Islamic Center of CapeCod. 3072 falmouth
            Road,Osterville MA,02655
          </Typography>
        </Grid>
        <Grid xs={6} item md={4}>
          <Typography className="footer-text2">1-508-428-0755</Typography>
        </Grid>
        <Grid item xs={6} md={3}>
          <Typography className="footer-text3">i_c_c_c@yahoo.com</Typography>
        </Grid>
      </Grid>
    </>
  );
};
export default Footer;
